/** Object.assign() ponyfill for ES5 compatibility: */
const assign = require('es6-object-assign').assign;
const tokens = require('./tokens.json');
const colorArray = require('./colorArray');
const mdsTokens = require('./js/js-module');

module.exports = assign(tokens, {
  /** @deprecated */
  tokens: assign({}, tokens),
  colorArray,
  mdsTokens
});
